module.exports = __webpack_public_path__ + "static/media/study 201023.74d9b591.png";